import { Box, styled } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { BigotinSvg } from "~/assets/svg";
import { SignInForm } from "~/components/auth/sign-in-form";

const Container = styled(Box)(({ theme }) => ({
  // TODO: replace colors with theme values
  background: "linear-gradient(204deg, #4F6EF9 17.9%, #2848FB 87.14%)",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

const BackgroundSvg = styled(BigotinSvg)({
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 920,
  pointerEvents: "none",
});

const loginSearchSchema = z.object({
  status: z.enum(["link-sent", "error", "expired"]).optional(),
  email: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  component: LoginPage,
  validateSearch: loginSearchSchema,
  beforeLoad: ({ context }) => {
    if (context.authState.isLoadingAuth) return;

    if (context.authState.isAuthenticated) {
      throw redirect({ to: "/" });
    }
  },
});

function LoginPage() {
  const { status, email } = Route.useSearch();

  const statusMap: Record<string, boolean> = {
    error: true,
    expired: true,
  };

  const hasError = status ? statusMap[status] || false : false;

  return (
    <Container>
      <BackgroundSvg />
      <SignInForm
        hasStatusError={hasError}
        initialEmail={email}
        mode="login"
        expired={status === "expired"}
      />
    </Container>
  );
}
